import { graphql } from 'gatsby';

/* === MOCK DATA ====================================================================== */
const DIAGRAM_TITLE = {
  en: 'How does the CBX crossing process work?',
  es: '¿Cómo funciona el cruce por CBX?',
};

const DIAGRAM_ITEMS = {
  en: [
    [
      {
        backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento1.png',
        description: 'If you already have your flight from Tijuana (TIJ), get your CBX pass on our website or app.',
      },
      {
        backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento2.png',
        description: 'If you don’t have your flight yet, purchase it by selecting it from TJX (San Diego via CBX) — it already includes the CBX crossing to Tijuana!',
      },
    ],
    [{ backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento3.png', description: 'Cross from San Diego to the Tijuana International Airport via CBX.' }],
    [{ backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento4.png', description: 'Present valid immigration documents (passport and FMM Immigration Form).' }],
    [{ backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento5.png', description: 'Board your flight and enjoy your vacation!' }],
  ],
  es: [
    [
      {
        backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento1.png',
        description: 'Si ya tienes tu vuelo desde Tijuana (TIJ), adquiere tu pase CBX en nuestro sitio web o app.',
      },
      {
        backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento2.png',
        description: 'Si aún no tienes tu vuelo, cómpralo seleccionando la opción TJX (San Diego vía CBX) — ya incluye el cruce CBX hacia Tijuana.',
      },
    ],
    [{ backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento3.png', description: 'Cruza de San Diego al Aeropuerto Internacional de Tijuana a través de CBX.' }],
    [
      {
        backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento4.png',
        description: 'Presenta tus documentos migratorios vigentes (pasaporte y Forma Migratoria Múltiple - FMM) * Solicita tu FMM en línea si aún no la tienes.',
      },
    ],
    [{ backgroundImage: '/images/diagram_tmp_images/3-Funcionamiento5.png', description: '¡Aborda tu vuelo y disfruta tus vacaciones!' }],
  ],
};

/**
 * @param {Object} props
 * @param {string} locale
 */
export const diagramMapping = (props, locale) => {
  // const items = getKey(props, 'items');

  return {
    key: props?.key,
    title: DIAGRAM_TITLE[locale],
    items: DIAGRAM_ITEMS[locale],
  };
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment Diagram on StrapiWidgetrels {
    diagram {
      key: id
      widgetPosition
    }
  }
`;
